import { render, staticRenderFns } from "./SecureCode.vue?vue&type=template&id=85c6a790&scoped=true&"
import script from "./SecureCode.vue?vue&type=script&lang=ts&"
export * from "./SecureCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c6a790",
  null
  
)

export default component.exports